<template>
    <div class="headerWrapper">
        <div class="headerContent animated bounceInUp">

            <div class="floater">
                <Scrobbler>
                    <img class="nametag"
                         alt="nametag"
                         src="../assets/img/nametag.png">
                </Scrobbler>
            </div>

            <div class="arrowWrapper">
            </div>

        </div>
    </div>
</template>

<script>
    import Scrobbler from "./Scrobbler";

    export default {
        name: "Header",
        components: { Scrobbler }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/_variables.scss";

    @-webkit-keyframes bounce {
        0%, 20%, 50%, 80%, 100% {-webkit-transform: translateY(0);} 
        40% {-webkit-transform: translateY(-30px);}
        60% {-webkit-transform: translateY(-15px);}
    }
     
    @-moz-keyframes bounce {
        0%, 20%, 50%, 80%, 100% {-moz-transform: translateY(0);}
        40% {-moz-transform: translateY(-30px);}
        60% {-moz-transform: translateY(-15px);}
    }
     
    @-o-keyframes bounce {
        0%, 20%, 50%, 80%, 100% {-o-transform: translateY(0);}
        40% {-o-transform: translateY(-30px);}
        60% {-o-transform: translateY(-15px);}
    }
    @keyframes bounce {
        0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
        40% {transform: translateY(-30px);}
        60% {transform: translateY(-15px);}
    }

    .headerWrapper{
        grid-row:1/2;

        display: grid;
        grid-template-columns: repeat(4, 25vw);
        position: absolute;
        height: 100vh;
        width: 100vw;

        .headerContent{
            grid-column: 2/4;
            display: grid;
            grid-template-rows: 90vh 10vh;

            .floater{
                width: 100%;
            }

            .nametag{
                margin-left: auto;
                margin-right: auto;
                display: block;
                z-index: 10 !important;
                border: solid 0.2rem black;
                padding: 1rem;
                background: $gumGreen;
                box-sizing: border-box;
                margin-top: 20rem;
                position: relative;
                width: 100%;
            }

            .arrowWrapper{
                background: url('../assets/img/logo.png') no-repeat center;
                background-size: 130%;
                background-color: white;
                margin-left: auto;
                margin-right: auto;
                max-height: 60px;
                border-radius:30px;
                padding: 0.8rem;
                margin-bottom: 15px;
                width: 50px;
                border: 0.2rem solid black;
                animation: bounce 2s infinite;
                -webkit-animation: bounce 2s infinite;
                -moz-animation: bounce 2s infinite;
                -o-animation: bounce 2s infinite;                

                span {
                    display: none;
                }

                .textContainer{
                    text-align: right;
                    padding: 5rem 3rem 1rem 3rem;
                    height: 40%;

                    .tags{
                        color: #067d7f;
                        font-size: 2.3em;
                        font-style: italic;

                        &:first-child{
                            margin-top: 0;
                        }

                        &:last-of-type{
                            display: none;
                        }
                    }

                    .response{
                        color: black;
                        font-size: 1.2em;
                        margin-bottom: 2.1em;
                    }
                }

                .downArrow{
                    display: block;
                }
            }
        }

        @media screen and (max-width: $regularLaptopWidth){
            .headerContent{
                .floater{
                    width: inherit;
                }

                .nametag{
                    width: 100%;
                    margin-top: 70%;
                }
            }
        }

        @media screen and (max-width: $tabletWidth){
            .headerContent{
                .nametag{
                    width: 100%;
                }
                .contentWrapper{
                    max-width: 100%;
                    .textContainer{
                        .tags{
                            font-size: 1.8em;
                        }
                        .response{
                            font-size: 0.9em;
                        }
                    }
                }
            }
        }

        @media screen and (max-width: $largeMobile){
            .headerContent{
                grid-column: 1/5;

                .contentWrapper{
                    .downArrow{
                        display: none;
                    }
                }
            }
        }
    }
</style>
